import { useState, useEffect } from "react";
import logger from "../../util/logger";

import { useNavigate } from "react-router-dom";

import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../../util/firebase";
import {
  query,
  collection,
  getDocs,
  where,
  addDoc,
  doc,
  updateDoc,
} from "firebase/firestore";

import emailjs from "@emailjs/browser";

import classnames from "classnames";

import { ScrollMenu } from "react-horizontal-scrolling-menu";
import "react-horizontal-scrolling-menu/dist/styles.css";

import BarLoader from "react-spinners/BarLoader";

import { PiShoppingCartSimple } from "react-icons/pi";
import { IoIosInformationCircleOutline } from "react-icons/io";

import { Button, Input, Modal, ModalBody } from "reactstrap";
import Swal from "sweetalert2";
import { IoClose } from "react-icons/io5";

import { useTranslation } from "react-i18next";
import ShopTutorialModal from "../../components/modals/ShopTutorialModal";
import N1coInfoModal from "../../components/modals/N1coInfoModal";

import SubscribeToMembershipModal from "../../components/modals/SubscribeToMembershipModal";
import RewardHistoryModal from "../../components/modals/RewardHistoryModal";
import memberships from "../../config/memberships";

function ShopPage() {
  const { t, i18n } = useTranslation("common");

  // Translations for the reward redemption user email (per-recipient variables)
  const rewardRedemptionUserTranslations = {
    en: {
      subject: "You have redeemed a reward",
      greeting: "Congrats!",
      paragraphIntro: "You have redeemed your tickets for",
      buttonText: "View your account",
      footerNotice: "If you need help, reply to info@sportleague.net",
      copyright: "© 2025 Sport League. All rights reserved.",
    },
    es: {
      subject: "Has canjeado una recompensa",
      greeting: "¡Felicidades!",
      paragraphIntro: "Has canjeado tus entradas por",
      buttonText: "Ver tu cuenta",
      footerNotice: "Si necesitas ayuda, responde a info@sportleague.net",
      copyright: "© 2025 Sport League. Todos los derechos reservados.",
    },
  };

  const [user] = useAuthState(auth);

  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const [shopTutorialModalIsVisible, setShopTutorialModalIsVisible] =
    useState(false);

  const toggleShopTutorialModal = () =>
    setShopTutorialModalIsVisible((prev) => !prev);

  const navigate = useNavigate();

  // eslint-disable-next-line
  const [userIsAdmin, setUserIsAdmin] = useState();
  const [userStarCoins, setUserStarCoins] = useState();
  const [userTickets, setUserTickets] = useState();
  const [userHasTicketBoost, setUserHasTicketBoost] = useState();
  const [userCountry, setUserCountry] = useState();
  const [n1coRewardsReleaseDate, setN1coRewardsReleaseDate] = useState();
  const [userUsername, setUserUsername] = useState();
  const [userMembershipTier, setUserMembershipTier] = useState();
  const [userMembershipExpiryDate, setUserMembershipExpiryDate] = useState();
  // eslint-disable-next-line
  // const [userUsername, setUserUsername] = useState();
  // const [isUserSportsPassHolder, setIsUserSportsPassHolder] = useState();
  const fetchUserData = async () => {
    try {
      setIsLoading(true);
      const q = query(collection(db, "users"), where("uid", "==", user?.uid));
      const doc = await getDocs(q);
      const data = doc.docs[0].data();
      logger.debug(data);
      setUserIsAdmin(data.role === "admin" ? true : false);
      setUserStarCoins(data.starCoins);
      setUserTickets(data.tickets);
      setUserHasTicketBoost(data.ticketBoostExpirationDatetime > new Date());
      setUserCountry(data.country);
      setN1coRewardsReleaseDate(data.n1coRewardsReleaseDate);
      setUserUsername(data.username);
      setUserMembershipTier(data.membershipTier);
      setUserMembershipExpiryDate(data.membershipExpiryDate);
      // setUserUsername(data.username);
      // setIsUserSportsPassHolder(data.isSportsPassHolder);

      // SHOP TUTORIAL

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching user data");
    }
  };
  useEffect(() => {
    if (user) {
      fetchUserData();
    }
    // eslint-disable-next-line
  }, [user]);

  // More general: check a product/reward object for allowance (used on card REDEEM buttons)
  const extractCashbackAmount = (text) => {
    if (!text) return NaN;
    const s = String(text);
    // 1) Parenthesized $ amounts like "($10.00)"
    const parenDollar = s.match(/\(\s*\$\s*(\d+(?:\.\d+)?)\s*\)/);
    if (parenDollar && parenDollar[1]) return Number(parenDollar[1]);

    // 2) Prefer $-prefixed amount anywhere
    const dollarPrefixed = s.match(/\$\s*(\d{1,3}(?:[,\d]*)(?:\.\d+)?)/);
    if (dollarPrefixed && dollarPrefixed[1]) {
      return Number(dollarPrefixed[1].replace(/,/g, ""));
    }

    // 3) Prefer decimals like 10.00
    const decimals = [...s.matchAll(/(\d+\.\d{1,2})/g)].map((m) =>
      Number(m[1])
    );
    if (decimals.length > 0) {
      const decInRange = decimals.find((n) => n >= 5 && n <= 500);
      if (decInRange !== undefined) return decInRange;
      return decimals[0];
    }

    // 4) Otherwise, collect all integer tokens and pick the first that looks like cashback (5..500)
    const all = [...s.matchAll(/(\d+(?:\.\d+)?)/g)].map((m) => Number(m[1]));
    if (all.length === 0) return NaN;
    const inRange = all.find((n) => n >= 5 && n <= 500);
    if (inRange !== undefined) return inRange;
    return all[0];
  };

  // Parse both numeric amount and original display substring (if any)
  const getCashbackAmountAndDisplay = (text) => {
    const s = String(text || "");
    const paren = s.match(/\(\s*\$\s*(\d+(?:\.\d+)?)\s*\)/);
    if (paren && paren[1])
      return {
        amount: Number(paren[1]),
        display: paren[0].replace(/[()]/g, "").trim(),
      };
    const dollar = s.match(/\$\s*(\d{1,3}(?:[,\d]*)(?:\.\d+)?)/);
    if (dollar && dollar[1])
      return {
        amount: Number(dollar[1].replace(/,/g, "")),
        display: dollar[0].trim(),
      };
    const fallback = extractCashbackAmount(s);
    return {
      amount: fallback,
      display: isNaN(fallback) ? null : `$${fallback}`,
    };
  };

  const isProductAllowedByMembership = (product) => {
    try {
      if (!product) return true;
      const rewardName = String(product?.name || "").toLowerCase();
      const looksLikeCashback =
        rewardName.includes("n1co") ||
        rewardName.includes("$") ||
        rewardName.includes("cashback");
      if (!looksLikeCashback) return true;

      const { amount } = getCashbackAmountAndDisplay(product?.name);

      // Allow $5 and $10 n1co cashback for free users explicitly (some
      // parsing paths can accidentally pick up numbers like "1" from
      // ticket counts elsewhere in the UI). If the product looks like an
      // n1co cashback and the parsed amount is 5 or 10, allow it.
      if (rewardName.includes("n1co") && (amount === 5 || amount === 10)) {
        return true;
      }

      const now = new Date();
      const userHasActiveMembership =
        userMembershipExpiryDate &&
        new Date(userMembershipExpiryDate.seconds * 1000) > now;
      const tier =
        userHasActiveMembership && userMembershipTier
          ? userMembershipTier
          : undefined;

      const allowedRange =
        tier && memberships[tier]
          ? memberships[tier].redeemableRange
          : { min: 5, max: 10 };

      if (isNaN(amount)) return false;
      return amount >= allowedRange.min && amount <= allowedRange.max;
    } catch (err) {
      return false;
    }
  };

  const handleRedeemButtonClick = (product) => {
    if (!isProductAllowedByMembership(product)) {
      // show friendly message
      const rewardName = String(product?.name || "");
      const amount = extractCashbackAmount(product?.name);
      let displayAmountStr = null;
      const parenMatch = String(product?.name || "").match(
        /\(\s*\$\s*\d+(?:\.\d+)?\s*\)/
      );
      if (parenMatch)
        displayAmountStr = parenMatch[0].replace(/[()]/g, "").trim();
      if (!displayAmountStr) {
        const dollarMatch = String(product?.name || "").match(
          /\$\s*\d+(?:\.\d+)?/
        );
        if (dollarMatch) displayAmountStr = dollarMatch[0].trim();
      }
      if (!displayAmountStr && amount !== null && !isNaN(amount))
        displayAmountStr = `$${amount}`;
      const now = new Date();
      const userHasActiveMembership =
        userMembershipExpiryDate &&
        new Date(userMembershipExpiryDate.seconds * 1000) > now;
      const tier =
        userHasActiveMembership && userMembershipTier
          ? userMembershipTier
          : "free";
      const allowedRange =
        tier && memberships[tier]
          ? memberships[tier].redeemableRange
          : { min: 5, max: 10 };

      Swal.fire({
        title: t("notAllowedTitle"),
        html: `${t("youCannotRedeem")} <b>${rewardName}</b> ${t(
          "withYourCurrentMembership"
        )}<br/>${t("allowedForYourTier")} (${tier}): <b>$${allowedRange.min}–$${
          allowedRange.max
        }</b>.`,
        icon: "error",
        confirmButtonColor: "#005EE1",
        confirmButtonText: t("ok"),
      });
      return;
    }

    toggleRedeemTicketsForRewardModal(product);
  };

  const [activeCategory, setActiveCategory] = useState();
  const toggleActiveCategory = (category) => {
    if (category === activeCategory) {
      setActiveCategory();
    } else {
      setActiveCategory(category);
    }
  };

  const [cart, setCart] = useState();

  const createCart = async () => {
    try {
      setIsLoading(true);

      await addDoc(collection(db, "carts"), {
        ownerUid: user.uid,
        items: [1],
      });
      const q = query(
        collection(db, "carts"),
        where("ownerUid", "==", user?.uid)
      );
      const doc = await getDocs(q);
      const data = doc.docs[0]?.data();
      setCart(data);
    } catch (err) {
      console.error(err);
      alert(err.message);
    }
  };

  const fetchCart = async () => {
    try {
      setIsLoading(true);

      const q = query(
        collection(db, "carts"),
        where("ownerUid", "==", user?.uid)
      );
      const doc = await getDocs(q);
      const data = doc.docs[0]?.data();

      if (data) {
        setCart(data);
      } else {
        createCart();
      }

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching cart");
    }
  };

  useEffect(() => {
    if (user) {
      fetchCart();
    }
    // eslint-disable-next-line
  }, [user]);

  const [products, setProducts] = useState();
  const fetchProducts = async () => {
    try {
      setIsLoading(true);

      let fetchedProducts = [];
      const q = query(collection(db, "products"));
      const docs = await getDocs(q);
      docs.forEach((doc) => {
        const newProduct = doc.data();
        if (
          newProduct.category === "AVATAR ICONS" ||
          newProduct.category === "PROFILE BANNERS"
        ) {
          if (
            (new Date(newProduct.activeFrom) < new Date() &&
              new Date(newProduct.activeTo) > new Date()) ||
            (!newProduct.activeFrom && !newProduct.activeTo)
          ) {
            fetchedProducts.push(newProduct);
          }
        } else {
          fetchedProducts.push(newProduct);
        }
      });

      fetchedProducts.sort((a, b) => {
        return a.price - b.price;
      });

      setProducts(fetchedProducts);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching products");
    }
  };

  useEffect(() => {
    fetchProducts();
    // eslint-disable-next-line
  }, []);

  const addItemToCart = async (item) => {
    // if (!userUsername === 'Kraken8'){
    //   if ('TICKET BOOSTS'){
    //     Swal.fire({
    //       text: "Coming soon!",
    //       icon: 'warning',
    //       confirmButtonColor: '#005EE1',
    //       confirmButtonText: "OKAY",
    //     })
    //     return;
    //   }
    // }

    if (userHasTicketBoost && item.category === "TICKET BOOSTS") {
      Swal.fire({
        text: "You already have an active ticket boost",
        icon: "warning",
        confirmButtonColor: "#005EE1",
        confirmButtonText: "OKAY",
      });
      return;
    }

    if (
      cart?.items.filter((e) => e.itemCategory === "TICKET BOOSTS").length >
        0 &&
      item.category === "TICKET BOOSTS"
    ) {
      Swal.fire({
        text: "You already have a ticket boost in your cart",
        icon: "warning",
        confirmButtonColor: "#005EE1",
        confirmButtonText: "OKAY",
      });
      return;
    }

    if (
      cart?.items.filter((e) => e.itemCategory === "BUNDLE").length > 0 &&
      item.category === "BUNDLE"
    ) {
      Swal.fire({
        text: "You already have the bundle in your cart",
        icon: "warning",
        confirmButtonColor: "#005EE1",
        confirmButtonText: "OKAY",
      });
      return;
    }

    if (user) {
      setIsLoading(true);

      try {
        let newCartItems = cart?.items;

        logger.debug(item.category);
        logger.debug(newCartItems);
        // if (item.category === 'SPORTS PASS'){
        //   if (newCartItems.filter(e => e.itemCategory === 'SPORTS PASS').length > 0){
        //     const index = newCartItems.findIndex(item => item.itemCategory === 'SPORTS PASS');
        //     newCartItems.splice(index, 1);
        //   }
        // }

        newCartItems.push({
          itemUid: item.uid,
          itemCategory: item.category,
          itemImage: item.image,
          itemName: item.name,
          itemPrice: item.price,
          itemQuantity: 1,
          bundleProducts: item.category === "BUNDLE" ? item.products : null,
        });

        const cartRef = query(
          collection(db, "carts"),
          where("ownerUid", "==", user?.uid)
        );
        const findCarts = await getDocs(cartRef);
        findCarts.forEach(async (cart) => {
          const getCart = doc(db, "carts", cart.id);
          await updateDoc(getCart, {
            items: newCartItems,
          });
        });

        if (bundleModalIsOpen) {
          setBundleModalIsOpen(false);
        }

        Swal.fire({
          text: "Item added to cart",
          icon: "success",
          confirmButtonColor: "#005EE1",
          confirmButtonText: "OKAY",
        });
        window.scrollTo(0, 0);

        setIsLoading(false);
      } catch (err) {
        console.error(err);
        setIsLoading(false);
      }
    } else {
      Swal.fire({
        text: "You need an account to add an item to your cart. Would you like to create one now?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#005EE1",
        confirmButtonText: "YES, PLEASE",
        cancelButtonText: "NO, CANCEL",
      }).then(async (result) => {
        if (result.isConfirmed) {
          navigate("/register");
        }
      });
    }
    // } else {
    //   Swal.fire({
    //     text: "Coming soon!",
    //     icon: 'warning',
    //     confirmButtonColor: '#005EE1',
    //     confirmButtonText: "Okay",
    //   })
    // }
  };

  // eslint-disable-next-line
  const [
    convertStarCoinsToTicketsModalIsOpen,
    setConvertStarCoinsToTicketsModalIsOpen,
  ] = useState(false);
  const toggleConvertStarCoinsToTicketsModal = () => {
    // if (userIsAdmin){
    setConvertStarCoinsToTicketsModalIsOpen(
      !convertStarCoinsToTicketsModalIsOpen
    );
    // } else {
    // Swal.fire({
    //   text: "Coming soon!",
    //   icon: 'warning',
    //   confirmButtonColor: '#005EE1',
    //   confirmButtonText: "Okay",
    // })
    // }
  };

  const [value, setValue] = useState(0);

  const getTicketsToConvert = () => {
    return value * 10;
  };

  const getTicketsToConvertDisplay = () => {
    return (value * 10).toLocaleString();
  };

  const convertTicketsToStarCoins = async () => {
    Swal.fire({
      text: t("convertTicketsConfirm"),
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#005EE1",
      confirmButtonText: t("yesConvert"),
      cancelButtonText: t("noCancel"),
    }).then(async (result) => {
      if (result.isConfirmed) {
        setIsLoading(true);

        try {
          const userRef = query(
            collection(db, "users"),
            where("uid", "==", user?.uid)
          );
          const findUsers = await getDocs(userRef);
          findUsers.forEach(async (userObject) => {
            const getUser = doc(db, "users", userObject.id);
            await updateDoc(getUser, {
              starCoins: userStarCoins
                ? userStarCoins + getTicketsToConvert()
                : getTicketsToConvert(),
              tickets: userTickets - value,
            }).then(() => {
              fetchUserData();
            });
          });

          // Dispatch custom event to notify App.js to refresh wallet data
          window.dispatchEvent(new CustomEvent("userWalletUpdated"));

          Swal.fire({
            text: t("convertTicketsSuccess"),
            icon: "success",
            confirmButtonColor: "#005EE1",
            confirmButtonText: t("ok"),
          });
          toggleConvertStarCoinsToTicketsModal();
          setValue(0);
          setIsLoading(false);
        } catch (err) {
          console.error(err);
          setIsLoading(false);
        }
      }
    });
  };

  // const doesCartContainSportPass = () => {
  //   if (cart) {
  //     if (
  //       cart.items.filter((e) => e.itemCategory === "SPORTS PASS").length > 0
  //     ) {
  //       return true;
  //     } else {
  //       return false;
  //     }
  //   }
  // };

  // const showUserIsAlreadySportsPassHolderPopup = () => {
  //   Swal.fire({
  //     text: "You are already a Sports Pass holder",
  //     icon: "warning",
  //     confirmButtonColor: "#005EE1",
  //     confirmButtonText: "OKAY",
  //   });
  // };

  // REWARDS

  const [rewards, setRewards] = useState();
  const fetchRewards = async () => {
    try {
      setIsLoading(true);

      let fetchedRewards = [];
      const q = query(collection(db, "rewards"));
      const docs = await getDocs(q);
      docs.forEach((doc) => {
        const newReward = doc.data();
        if (newReward.isActive === true) {
          if (parseInt(newReward.quantityAvailable) > 0) {
            if (newReward.countries) {
              let rewardCountries = [];
              newReward.countries.forEach((country) => {
                rewardCountries.push(country.label);
              });
              if (rewardCountries.includes(userCountry)) {
                fetchedRewards.push(newReward);
              }
            } else {
              fetchedRewards.push(newReward);
            }
          }
        }
      });

      fetchedRewards.sort((a, b) => {
        return a.priceInTickets - new Date(b.priceInTickets);
      });

      // Move 'n1co' rewards to the top
      fetchedRewards = [
        ...fetchedRewards.filter((r) =>
          r.name?.toLowerCase()?.includes("n1co")
        ),
        ...fetchedRewards.filter(
          (r) => !r.name?.toLowerCase()?.includes("n1co")
        ),
      ];

      setRewards(fetchedRewards);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching products");
    }
  };

  useEffect(() => {
    if (userCountry) {
      fetchRewards();
    }
    // eslint-disable-next-line
  }, [userCountry]);

  // eslint-disable-next-line
  const [
    redeemTicketsForRewardModalIsOpen,
    setRedeemTicketsForRewardModalIsOpen,
  ] = useState(false);
  // eslint-disable-next-line
  const [rewardForModal, setRewardForModal] = useState();
  const toggleRedeemTicketsForRewardModal = (reward) => {
    if (!redeemTicketsForRewardModalIsOpen) {
      if (reward?.name?.toLowerCase()?.includes("n1co")) {
        if (
          !n1coRewardsReleaseDate ||
          Date.now() > n1coRewardsReleaseDate.toDate()
        ) {
          setRewardForModal(reward);
          setRedeemTicketsForRewardModalIsOpen(
            !redeemTicketsForRewardModalIsOpen
          );
        } else {
          Swal.fire({
            text: "Sorry! You can only redeem cashback once a week",
            icon: "error",
            confirmButtonColor: "#005EE1",
            confirmButtonText: "OKAY",
          });
        }
      } else {
        setRewardForModal(reward);
        setRedeemTicketsForRewardModalIsOpen(
          !redeemTicketsForRewardModalIsOpen
        );
      }
    } else {
      setRedeemTicketsForRewardModalIsOpen(!redeemTicketsForRewardModalIsOpen);
    }
  };

  const redeemTicketsForReward = async () => {
    setIsLoading(true);

    try {
      // Enforce membership redeemable gift-card / cashback ranges.
      // We consider items that reference "n1co", contain a "$" amount, or mention "cashback" as gift-card/cashback rewards.
      const rewardName = String(rewardForModal?.name || "").toLowerCase();
      const looksLikeCashback =
        rewardName.includes("n1co") ||
        rewardName.includes("$") ||
        rewardName.includes("cashback");

      if (looksLikeCashback) {
        // Try to parse a dollar amount from the reward name (e.g. "$5", "5$", "5 USD").
        // Use the robust parser which prefers parenthesized dollar amounts
        // like "($10.00)" and $-prefixed tokens. This avoids accidentally
        // matching ticket counts (e.g. "1,000") which can appear nearby
        // in the modal markup.
        const { amount } = getCashbackAmountAndDisplay(rewardForModal?.name);

        // Determine user's active membership tier (only active memberships grant wider ranges)
        const now = new Date();
        const userHasActiveMembership =
          userMembershipExpiryDate &&
          new Date(userMembershipExpiryDate.seconds * 1000) > now;
        const tier =
          userHasActiveMembership && userMembershipTier
            ? userMembershipTier
            : undefined;

        // Default allowed range for non-members (free users) is $5-$10 per product spec notes
        const allowedRange =
          tier && memberships[tier]
            ? memberships[tier].redeemableRange
            : { min: 5, max: 10 };

        if (isNaN(amount)) {
          Swal.fire({
            text: t("unableToDetermineCashback"),
            icon: "error",
            confirmButtonColor: "#005EE1",
            confirmButtonText: t("ok"),
          });
          setIsLoading(false);
          return;
        }

        if (amount < allowedRange.min || amount > allowedRange.max) {
          Swal.fire({
            text: t("membershipNotAllowingRedeem", {
              amount: `$${amount}`,
              min: allowedRange.min,
              max: allowedRange.max,
            }),
            icon: "error",
            confirmButtonColor: "#005EE1",
            confirmButtonText: t("ok"),
          });
          setIsLoading(false);
          return;
        }
      }

      // If this is an N1CO cashback reward, require the user's DUI (national ID)
      let duiForRedemption = null;
      if (
        String(rewardForModal?.name || "")
          .toLowerCase()
          .includes("n1co")
      ) {
        const { value: dui } = await Swal.fire({
          title: t("duiRequiredTitle"),
          text: t("duiRequiredText"),
          input: "text",
          inputPlaceholder: t("duiInputPlaceholder"),
          showCancelButton: true,
          confirmButtonText: t("submit").toUpperCase(),
          cancelButtonText: t("cancel").toUpperCase(),
          confirmButtonColor: "#005EE1",
          inputValidator: (value) => {
            if (!value) return t("duiRequiredValidation");
            return null;
          },
        });
        if (!dui) {
          // user cancelled or didn't provide DUI
          setIsLoading(false);
          return;
        }
        duiForRedemption = dui;
      }

      const userRef = query(
        collection(db, "users"),
        where("uid", "==", user?.uid)
      );
      const findUsers = await getDocs(userRef);
      findUsers.forEach(async (userObject) => {
        const getUser = doc(db, "users", userObject.id);

        await updateDoc(getUser, {
          tickets: userTickets - rewardForModal.priceInTickets,
          n1coRewardsReleaseDate: new Date(
            Date.now() + 7 * 24 * 60 * 60 * 1000
          ),
        }).then(() => {
          fetchUserData();
          setIsLoading(true);
        });
      });

      const publicKey = "Ki5BETKiWrS6RDEP_";

      // Admin email

      const serviceId = "sportleague_outlook";
      const templateId = "rewardRedemptionAdmin";

      const templateParams = {
        userUsername: user.username,
        userEmail: user.email,
        rewardRedeemed: rewardForModal.name,
        // include DUI for admin notifications when present
        dui: duiForRedemption || "",
      };

      await emailjs.send(serviceId, templateId, templateParams, publicKey).then(
        (response) => {
          logger.info("SUCCESS!", response.status, response.text);
        },
        (error) => {
          logger.error("FAILED...", error);
        }
      );

      // User notification

      const serviceIdUser = "sportleague_outlook";
      const templateIdUser = "rewardRedemptionUser";

      // determine recipient language: prefer stored user language, then i18n current language, then fallback to en
      const recipientLanguage = user?.language?.value || i18n?.language || "en";
      const emailStrings =
        rewardRedemptionUserTranslations[recipientLanguage] ||
        rewardRedemptionUserTranslations.en;

      const templateParamsUser = {
        userUsername: user.username,
        userEmail: user.email,
        rewardRedeemed: rewardForModal.name,
        // localized variables used by the EmailJS template
        subject: emailStrings.subject,
        greeting: emailStrings.greeting,
        paragraphIntro: emailStrings.paragraphIntro,
        buttonText: emailStrings.buttonText,
        footerNotice: emailStrings.footerNotice,
      };

      await emailjs
        .send(serviceIdUser, templateIdUser, templateParamsUser, publicKey)
        .then(
          (response) => {
            logger.info("SUCCESS!", response.status, response.text);
          },
          (error) => {
            logger.error("FAILED...", error);
          }
        );

      Swal.fire({
        text: t("rewardRedeemedSuccess"),
        icon: "success",
        confirmButtonColor: "#005EE1",
        confirmButtonText: t("ok").toUpperCase(),
      });

      const rewardRef = query(
        collection(db, "rewards"),
        where("uid", "==", rewardForModal?.uid)
      );
      const findRewards = await getDocs(rewardRef);
      findRewards.forEach(async (rewardObject) => {
        const getReward = doc(db, "rewards", rewardObject.id);

        await updateDoc(getReward, {
          quantityAvailable: parseInt(rewardForModal.quantityAvailable) - 1,
        }).then(() => {
          fetchUserData();
          setIsLoading(true);
        });
      });

      await addDoc(collection(db, "rewardRedemptions"), {
        redeemerUid: user?.uid,
        redeemerUsername: userUsername,
        rewardUid: rewardForModal?.uid,
        rewardName: rewardForModal?.name,
        rewardImage: rewardForModal?.image,
        rewardPriceInTickets: rewardForModal?.priceInTickets,
        redemptionDate: new Date(),
        dui: duiForRedemption || null,
      });

      toggleRedeemTicketsForRewardModal();
      setIsLoading(false);
    } catch (err) {
      console.error(err);
      setIsLoading(false);
    }
  };

  //

  // BUNDLES

  const [activeBundles, setActiveBundles] = useState([]);
  const fetchBundle = async () => {
    try {
      setIsLoading(true);

      const active = [];
      const q = query(collection(db, "bundles"));
      const docs = await getDocs(q);
      docs.forEach((doc) => {
        const newBundle = doc.data();
        if (newBundle.status === "Active") {
          active.push(newBundle);
        }
      });

      // Allow up to 2 active bundles to be displayed (business request)
      setActiveBundles(active.slice(0, 2));

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching bundle");
    }
  };

  useEffect(() => {
    fetchBundle();
    // eslint-disable-next-line
  }, []);

  const [bundleModalIsOpen, setBundleModalIsOpen] = useState();
  const [bundleForModal, setBundleForModal] = useState();
  const toggleBundleModal = (bundle) => {
    if (bundle) {
      setBundleForModal(bundle);
    }
    setBundleModalIsOpen(!bundleModalIsOpen);
  };

  //

  // const buyTicketBoost = async (ticketBoost) => {
  //   setIsLoading(true);

  //   const ticketBoostDurationInHours = ticketBoost.name.split(' ')[0];

  //   try {
  //     const userRef = query(collection(db, "users"), where("uid", "==", user?.uid));
  //     const findUsers = await getDocs(userRef);
  //     findUsers.forEach( async (userObject) => {
  //       const getUser = doc(db, 'users', userObject.id);
  //       await updateDoc(getUser, {
  //         ticketBoostExpirationDatetime: new Date(new Date().getTime() + (ticketBoostDurationInHours * 60 * 60 * 1000))
  //       }).then(() => {
  //         fetchUserData();
  //       });
  //     });

  //     Swal.fire({
  //       text: "Ticket boost bought successfully",
  //       icon: 'success',
  //       confirmButtonColor: '#005EE1',
  //       confirmButtonText: "OKAY",
  //     });

  //     setIsLoading(false);
  //   } catch (err) {
  //     console.error(err);
  //     setIsLoading(false);
  //   }
  // }

  const [bundleItemPreviewModalIsOpen, setBundleItemPreviewModalIsOpen] =
    useState();
  const [bundleItemForModal, setBundleItemForModal] = useState();
  const toggleBundleItemPreviewModal = (product) => {
    if (product) {
      setBundleItemForModal(product);
    }
    setBundleItemPreviewModalIsOpen(!bundleItemPreviewModalIsOpen);
  };

  // const [sportsPassForModal, setSportsPassForModal] = useState();
  // const [sportsPassModalIsOpen, setSportsPassModalIsOpen] = useState();
  // const toggleSportsPassModal = (sportsPass) => {
  //   if (sportsPass) {
  //     setSportsPassForModal(sportsPass);
  //   }
  //   setSportsPassModalIsOpen(!sportsPassModalIsOpen);
  // };

  const [membershipModalIsOpen, setMembershipModalIsOpen] = useState();
  const [membershipForModal, setMembershipForModal] = useState();

  const toggleSubscribeToMembershipModal = (membershipType) => {
    // membershipType may sometimes be an event object (when reactstrap's toggle is triggered).
    // Only set the membershipForModal state when a string is provided.
    if (typeof membershipType === "string") {
      setMembershipForModal(membershipType);
    }
    setMembershipModalIsOpen(!membershipModalIsOpen);
  };

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="shopPage" className="page">
      <ShopTutorialModal
        isOpen={shopTutorialModalIsVisible}
        onClose={() => setShopTutorialModalIsVisible(false)}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <h1 style={{ margin: 0 }}>{t("shop").toUpperCase()}</h1>
          <IoIosInformationCircleOutline
            onClick={toggleShopTutorialModal}
            style={{
              marginTop: -12,
              marginLeft: 5,
              cursor: "pointer",
              color: "#005EE1",
              width: 26,
              height: 26,
            }}
          />
        </div>
        <div id="shopPageCart">
          <PiShoppingCartSimple
            onClick={() =>
              cart?.items?.length > 0 ? navigate("/shop/checkout") : null
            }
            style={
              cart?.items?.length > 0
                ? { color: "#FABB00" }
                : { color: "#FABB0099" }
            }
          />
          <span>{cart?.items?.length > 0 ? cart?.items?.length : null}</span>
        </div>
      </div>
      <ScrollMenu>
        {/* <div className={classnames('shopCategoriesMenuItem',{active: (activeCategory === 'BUNDLES')})} onClick={() => toggleActiveCategory('BUNDLES')}>
          <p>
            {t('bundles').toUpperCase()}
          </p>
        </div> */}
        {/* <div className={classnames('shopCategoriesMenuItem',{active: (activeCategory === 'SPORTS PASS')})} onClick={() => toggleActiveCategory('SPORTS PASS')}>
          <p>
            SPORTS PASS
          </p>
        </div> */}
        {/* <div
          className={classnames("shopCategoriesMenuItem", {
            active: activeCategory === "KEYS",
          })}
          onClick={() => toggleActiveCategory("KEYS")}
        >
          <p>{t("keys").toUpperCase()}</p>
        </div> */}
        <div
          className={classnames("shopCategoriesMenuItem", {
            active: activeCategory === "MEMBERSHIPS",
          })}
          onClick={() => toggleActiveCategory("MEMBERSHIPS")}
        >
          <p>{t("memberships").toUpperCase()}</p>
        </div>
        <div
          className={classnames("shopCategoriesMenuItem", {
            active: activeCategory === "STAR COINS",
          })}
          onClick={() => toggleActiveCategory("STAR COINS")}
        >
          <p>{t("starCoins").toUpperCase()}</p>
        </div>
        <div
          className={classnames("shopCategoriesMenuItem", {
            active: activeCategory === "AVATAR ICONS",
          })}
          onClick={() => toggleActiveCategory("AVATAR ICONS")}
        >
          <p>{t("avatarIcons").toUpperCase()}</p>
        </div>
        <div
          className={classnames("shopCategoriesMenuItem", {
            active: activeCategory === "PROFILE BANNERS",
          })}
          onClick={() => toggleActiveCategory("PROFILE BANNERS")}
        >
          <p>{t("profileBanners").toUpperCase()}</p>
        </div>
        {/* <div className={classnames('shopCategoriesMenuItem',{active: (activeCategory === 'EMOJIS')})} onClick={() => toggleActiveCategory('EMOJIS')}>
          <p>
            EMOJIS
          </p>
        </div>
        <div className={classnames('shopCategoriesMenuItem',{active: (activeCategory === 'STICKERS')})} onClick={() => toggleActiveCategory('STICKERS')}>
          <p>
            STICKERS
          </p>
        </div> */}
        {/* <div className={classnames('shopCategoriesMenuItem',{active: (activeCategory === 'TICKET BOOSTS')})} onClick={() => toggleActiveCategory('TICKET BOOSTS')}>
          <p>
            {t('ticketBoosts').toUpperCase()}
          </p>
        </div> */}
        {/* <div className={classnames('shopCategoriesMenuItem',{active: (activeCategory === 'CREATE GROUP TOKENS')})} onClick={() => toggleActiveCategory('CREATE GROUP TOKENS')}>
          <p>
            CREATE GROUP TOKENS
          </p>
        </div> */}
        <div
          className={classnames("shopCategoriesMenuItem", {
            active: activeCategory === "REWARDS",
          })}
          onClick={() => toggleActiveCategory("REWARDS")}
        >
          <p>{t("rewards").toUpperCase()}</p>
        </div>
      </ScrollMenu>
      <div style={{ marginTop: "1rem" }}>
        {/* BUNDLES */}
        {!activeCategory || activeCategory === "BUNDLES" ? (
          <div className="shopPageSection">
            <h1>{t("bundle").toUpperCase()}</h1>
            <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
              {(activeBundles || []).map((b, idx) => (
                <div
                  key={b.uid || idx}
                  className="shopCard"
                  style={{ marginRight: 0, width: 360 }}
                >
                  <div
                    className="shopCardImageContainer"
                    style={{ paddingLeft: 0, paddingRight: 0 }}
                  >
                    <img
                      alt="productImage"
                      src={
                        b?.image
                          ? b.image
                          : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
                      }
                      style={{ width: "100%", maxWidth: "100%" }}
                    />
                  </div>
                  <div style={{ padding: "1rem", paddingTop: "0.5rem" }}>
                    <p className="shopCardName">{b?.name}</p>
                    <p className="shopCardPrice">${b?.price?.toFixed(2)}</p>
                    <Button
                      onClick={() => toggleBundleModal(b)}
                      className="primaryBtn"
                      disabled={b?.purchaserUids?.includes(user?.uid)}
                    >
                      {b?.purchaserUids?.includes(user?.uid)
                        ? t("purchased").toUpperCase()
                        : t("seeMore").toUpperCase()}
                    </Button>
                  </div>
                </div>
              ))}
            </div>
            {/* <ScrollMenu>
                {
                  // eslint-disable-next-line
                  bundles?.map(bundle => {
                    if (bundle.status === 'Active'){
                      return (
                        <div className='shopCard'>
                          <div className='shopCardImageContainer'>
                            <img
                              alt="productImage"
                              src={bundle.image ? bundle.image : 'https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3'}
                            />
                          </div>
                          <div style={{padding: '1rem', paddingTop: '0.5rem'}}>
                            <p className='shopCardName'>
                              {bundle.name}
                            </p>
                            <p className='shopCardPrice'>
                              ${bundle.price.toFixed(2)}
                            </p>
                            <Button onClick={() => toggleBundleModal(bundle)} className='primaryBtn'>
                              {t('seeMore').toUpperCase()}
                            </Button>
                          </div>
                        </div>
                      )
                    }
                  })
                }
              </ScrollMenu> */}
            {/*  */}
            <Modal
              id="shopBundleModal"
              isOpen={bundleModalIsOpen}
              toggle={toggleBundleModal}
              size={"lg"}
            >
              <ModalBody>
                <div className="modalHeader" style={{ marginBottom: "1rem" }}>
                  <div></div>
                  <IoClose onClick={toggleBundleModal} />
                </div>
                <div>
                  <h1>{t("bundle").toUpperCase()}</h1>
                  <div style={{ marginTop: "1rem" }}>
                    <div className="shopCardImageContainer">
                      <img
                        alt="productImage"
                        src={
                          bundleForModal?.image
                            ? bundleForModal.image
                            : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
                        }
                      />
                    </div>
                    <div>
                      <p className="shopCardName">{bundleForModal?.name}</p>
                      <p className="shopCardPrice">
                        ${bundleForModal?.price?.toFixed(2)}
                      </p>
                      <p style={{ marginBottom: "0.5rem" }}>
                        {t("bundleIncludes")}
                      </p>
                      {bundleForModal?.products?.map((product) => {
                        return (
                          <div
                            onClick={() =>
                              toggleBundleItemPreviewModal(product)
                            }
                            className="bundleForModalProduct"
                          >
                            <p>
                              <span className="bundleProductCategory">
                                {product.category}
                              </span>
                              &nbsp;
                              <span className="bundleProductName">
                                {product.name}
                              </span>
                            </p>
                            <p className="bundleProductPrice">
                              ${product.price}
                            </p>
                          </div>
                        );
                      })}
                      <Modal
                        id="bundleItemPreviewModal"
                        isOpen={bundleItemPreviewModalIsOpen}
                        toggle={toggleBundleItemPreviewModal}
                        size={"lg"}
                      >
                        <ModalBody>
                          <div
                            className="modalHeader"
                            style={{ marginBottom: "1rem" }}
                          >
                            <div></div>
                            <IoClose onClick={toggleBundleItemPreviewModal} />
                          </div>
                          <div style={{ textAlign: "center" }}>
                            <img
                              alt="productImage"
                              src={
                                bundleItemForModal?.image
                                  ? bundleItemForModal.image
                                  : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
                              }
                              style={{
                                width: "100%",
                                maxWidth: 500,
                                borderRadius: 20,
                                marginBottom: "0.5rem",
                              }}
                            />
                          </div>
                        </ModalBody>
                      </Modal>
                      <Button
                        onClick={() => addItemToCart(bundleForModal)}
                        className="primaryBtn"
                        style={{ marginTop: "0.5rem" }}
                      >
                        {t("addToCart").toUpperCase()}
                      </Button>
                    </div>
                  </div>
                </div>
              </ModalBody>
            </Modal>
          </div>
        ) : null}
        {/*  */}
        {/* MEMBERSHIPS */}
        {!activeCategory || activeCategory === "MEMBERSHIPS" ? (
          <div className="shopPageSection">
            <h1>{t("memberships").toUpperCase()}</h1>
            <ScrollMenu>
              <div className="shopCard">
                <div className="shopCardImageContainer">
                  <img
                    alt="productImage"
                    src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fmemberships%2Fsilver.png?alt=media&token=240c0461-9962-47ec-a3ee-ce0b8b966a49"
                  />
                </div>
                <div style={{ padding: "1rem", paddingTop: "0.5rem" }}>
                  <p className="shopCardName">
                    {t("vipSilverMembership").toUpperCase()}
                  </p>
                  <p className="shopCardPrice">{t("priceMonthly5_99")}</p>
                  {(() => {
                    const isActiveMembership =
                      userMembershipExpiryDate &&
                      new Date(userMembershipExpiryDate.seconds * 1000) >
                        new Date();
                    const disabled =
                      isActiveMembership &&
                      userMembershipTier &&
                      userMembershipTier !== "silver";
                    return (
                      <Button
                        onClick={() =>
                          toggleSubscribeToMembershipModal("silver")
                        }
                        className="primaryBtn"
                        title={
                          disabled
                            ? `You have an active ${userMembershipTier} membership. You can only extend that tier.`
                            : undefined
                        }
                      >
                        {userMembershipTier === "silver"
                          ? t("extend").toUpperCase()
                          : disabled
                          ? t("seeMore").toUpperCase()
                          : t("subscribe").toUpperCase()}
                      </Button>
                    );
                  })()}
                </div>
              </div>
              <div className="shopCard">
                <div className="shopCardImageContainer">
                  <img
                    alt="productImage"
                    src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fmemberships%2Fgold.png?alt=media&token=69fa2c44-78e3-4229-8d81-7f744bfe3dea"
                  />
                </div>
                <div style={{ padding: "1rem", paddingTop: "0.5rem" }}>
                  <p className="shopCardName">
                    {t("vipGoldMembership").toUpperCase()}
                  </p>
                  <p className="shopCardPrice">{t("priceMonthly9_99")}</p>
                  {(() => {
                    const isActiveMembership =
                      userMembershipExpiryDate &&
                      new Date(userMembershipExpiryDate.seconds * 1000) >
                        new Date();
                    const disabled =
                      isActiveMembership &&
                      userMembershipTier &&
                      userMembershipTier !== "gold";
                    return (
                      <Button
                        onClick={() => toggleSubscribeToMembershipModal("gold")}
                        className="primaryBtn"
                        title={
                          disabled
                            ? `You have an active ${userMembershipTier} membership. You can only extend that tier.`
                            : undefined
                        }
                      >
                        {userMembershipTier === "gold"
                          ? t("extend").toUpperCase()
                          : disabled
                          ? t("seeMore").toUpperCase()
                          : t("subscribe").toUpperCase()}
                      </Button>
                    );
                  })()}
                </div>
              </div>
              <div className="shopCard">
                <div className="shopCardImageContainer">
                  <img
                    alt="productImage"
                    src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fmemberships%2Fplatinum.png?alt=media&token=2ad2dcac-33cd-4f24-ae4d-99e9f5907b32"
                  />
                </div>
                <div style={{ padding: "1rem", paddingTop: "0.5rem" }}>
                  <p className="shopCardName">
                    {t("vipPlatinumMembership").toUpperCase()}
                  </p>
                  <p className="shopCardPrice">{t("priceMonthly19_99")}</p>
                  {(() => {
                    const isActiveMembership =
                      userMembershipExpiryDate &&
                      new Date(userMembershipExpiryDate.seconds * 1000) >
                        new Date();
                    const disabled =
                      isActiveMembership &&
                      userMembershipTier &&
                      userMembershipTier !== "platinum";
                    return (
                      <Button
                        onClick={() =>
                          toggleSubscribeToMembershipModal("platinum")
                        }
                        className="primaryBtn"
                        title={
                          disabled
                            ? t("youHaveActiveMembershipExtendOnly", {
                                tier: userMembershipTier,
                              })
                            : undefined
                        }
                      >
                        {userMembershipTier === "platinum"
                          ? t("extend").toUpperCase()
                          : disabled
                          ? t("seeMore").toUpperCase()
                          : t("subscribe").toUpperCase()}
                      </Button>
                    );
                  })()}
                </div>
              </div>
              <SubscribeToMembershipModal
                membershipModalIsOpen={membershipModalIsOpen}
                toggleSubscribeToMembershipModal={
                  toggleSubscribeToMembershipModal
                }
                membershipForModal={membershipForModal}
                userMembershipTier={userMembershipTier}
                userMembershipExpiryDate={userMembershipExpiryDate}
              />
              {/* <Modal
                id="convertStarCoinsToTicketsModal"
                isOpen={convertStarCoinsToTicketsModalIsOpen}
                toggle={toggleConvertStarCoinsToTicketsModal}
                size={"lg"}
              >
                <ModalBody>
                  <div className="modalHeader" style={{ marginBottom: "1rem" }}>
                    <div></div>
                    <IoClose onClick={toggleConvertStarCoinsToTicketsModal} />
                  </div>
                  <div>
                    <h1>{t("convertTicketsToStarCoins").toUpperCase()}</h1>
                    <div style={{ marginTop: "1rem" }}>
                      <p>
                        {t("youHave")}{" "}
                        <span style={{ fontWeight: "bold", color: "#FABB00" }}>
                          {userTickets}
                        </span>{" "}
                        tickets
                      </p>
                      <div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <div id="convertStarCoinsToTicketsTickets">
                            <p>{getTicketsToConvertDisplay()} ⭐️</p>
                          </div>
                          <p style={{ marginBottom: 0 }}>1 🎟️ = 10 ⭐️</p>
                        </div>
                        <p className="inputLabel">{t("ticketsToConvert")}</p>
                        <Input
                          type="number"
                          className="authInput"
                          value={value}
                          onChange={(e) => setValue(e.target.value)}
                          placeholder={t("ticketsToConvert")}
                          style={{ marginBottom: "1rem" }}
                        />
                        <button
                          onClick={convertTicketsToStarCoins}
                          className="primaryBtn"
                          disabled={value < 1 || value > userTickets}
                        >
                          {t("convertNow").toUpperCase()}
                        </button>
                      </div>
                    </div>
                  </div>
                </ModalBody>
              </Modal> */}
            </ScrollMenu>
          </div>
        ) : null}
        {/*  */}
        {/* KEYS */}
        {/* {!activeCategory || activeCategory === "KEYS" ? (
          <div className="shopPageSection">
            <h1>{t("keys").toUpperCase()}</h1>
            <ScrollMenu>
              {
                // eslint-disable-next-line
                products?.map((product) => {
                  if (product.category === "KEYS") {
                    return (
                      <div className="shopCard">
                        <div className="shopCardImageContainer">
                          <img
                            alt="productImage"
                            src={
                              product.image
                                ? product.image
                                : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
                            }
                          />
                        </div>
                        <div style={{ padding: "1rem", paddingTop: "0.5rem" }}>
                          <p className="shopCardName">{product.name}</p>
                          <p className="shopCardPrice">
                            ${parseFloat(product?.price).toFixed(2)}
                          </p>
                          <Button
                            onClick={() => addItemToCart(product)}
                            className="primaryBtn"
                          >
                            {t("buyNow").toUpperCase()}
                          </Button>
                        </div>
                      </div>
                    );
                  }
                })
              }
            </ScrollMenu>
          </div>
        ) : null} */}
        {/*  */}
        {/* SPORTS PASS */}
        {/* {!activeCategory || activeCategory === "SPORTS PASS" ? (
          <div className="shopPageSection">
            <h1>SPORTS PASS</h1>
            <ScrollMenu>
              {
                // eslint-disable-next-line
                products?.map((product) => {
                  if (product.category === "SPORTS PASS") {
                    return (
                      <div className="shopCard">
                        <div className="shopCardImageContainer">
                          <img
                            alt="productImage"
                            src={
                              product.image
                                ? product.image
                                : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
                            }
                          />
                        </div>
                        <div style={{ padding: "1rem", paddingTop: "0.5rem" }}>
                          <p className="shopCardName">
                            {product.name}{" "}
                            {product.name === "1" ? "month" : t("months")}
                            {product.name === "3"
                              ? " (Pro)"
                              : product.name === "6"
                              ? " (Elite)"
                              : product.name === "12"
                              ? " (Master)"
                              : null}
                          </p>
                          <p className="shopCardPrice">
                            ${product.price.toFixed(2)}
                          </p>
                          <Button
                            onClick={() => toggleSportsPassModal(product)}
                            className="secondaryBtn"
                            style={{ marginBottom: "0.5rem" }}
                          >
                            {t("seeMore").toUpperCase()}
                          </Button>
                          <Modal
                            id="shopBundleModal"
                            isOpen={sportsPassModalIsOpen}
                            toggle={toggleSportsPassModal}
                            size={"lg"}
                          >
                            <ModalBody>
                              <div
                                className="modalHeader"
                                style={{ marginBottom: "1rem" }}
                              >
                                <div></div>
                                <IoClose onClick={toggleSportsPassModal} />
                              </div>
                              <div>
                                <h1>SPORTS PASS</h1>
                                <div style={{ marginTop: "1rem" }}>
                                  <div className="shopCardImageContainer">
                                    <img
                                      alt="productImage"
                                      src={
                                        sportsPassForModal?.image
                                          ? sportsPassForModal.image
                                          : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
                                      }
                                    />
                                  </div>
                                  <div>
                                    <p className="shopCardName">
                                      {sportsPassForModal?.name}{" "}
                                      {sportsPassForModal?.name === "1"
                                        ? "month"
                                        : t("months")}
                                      {sportsPassForModal?.name === "3"
                                        ? " (Pro)"
                                        : sportsPassForModal?.name === "6"
                                        ? " (Elite)"
                                        : sportsPassForModal?.name === "12"
                                        ? " (Master)"
                                        : null}
                                    </p>
                                    <p className="shopCardPrice">
                                      ${sportsPassForModal?.price?.toFixed(2)}
                                    </p>
                                    <p style={{ marginBottom: "0.5rem" }}>
                                      {t("sportsPassIncludes")}
                                    </p>
                                    <div className="bundleForModalProduct">
                                      <p>
                                        <span className="bundleProductCategory">
                                          TICKET BOOSTS
                                        </span>
                                        &nbsp;
                                        <span className="bundleProductName">
                                          {sportsPassForModal?.name === "3"
                                            ? `2x tickets ${t("for")} 3 ${t(
                                                "months"
                                              )}`
                                            : sportsPassForModal?.name === "6"
                                            ? `2x tickets ${t("for")} 6 ${t(
                                                "months"
                                              )}`
                                            : sportsPassForModal?.name === "12"
                                            ? `2x tickets ${t("for")} 12 ${t(
                                                "months"
                                              )}`
                                            : null}
                                        </span>
                                      </p>
                                      <p className="bundleProductPrice">
                                        $
                                        {sportsPassForModal?.name === "3"
                                          ? "14.97"
                                          : sportsPassForModal?.name === "6"
                                          ? "29.94"
                                          : sportsPassForModal?.name === "12"
                                          ? "59.88"
                                          : null}
                                      </p>
                                    </div>
                                    <div className="bundleForModalProduct">
                                      <p>
                                        <span className="bundleProductCategory">
                                          {t("starCoins").toUpperCase()}
                                        </span>
                                        &nbsp;
                                        <span className="bundleProductName">
                                          {sportsPassForModal?.name === "3"
                                            ? "500"
                                            : sportsPassForModal?.name === "6"
                                            ? "1,200"
                                            : sportsPassForModal?.name === "12"
                                            ? "3,000"
                                            : null}
                                        </span>
                                      </p>
                                      <p className="bundleProductPrice">
                                        $
                                        {sportsPassForModal?.name === "3"
                                          ? "4.99"
                                          : sportsPassForModal?.name === "6"
                                          ? "9.99"
                                          : sportsPassForModal?.name === "12"
                                          ? "24.99"
                                          : null}
                                      </p>
                                    </div>
                                    <div
                                      className="bundleForModalProduct"
                                      style={{ marginBottom: "1rem" }}
                                    >
                                      <p>
                                        <span className="bundleProductCategory">
                                          SEASON KEYS
                                        </span>
                                        &nbsp;
                                        <span className="bundleProductName">
                                          {sportsPassForModal?.name === "3"
                                            ? "2"
                                            : sportsPassForModal?.name === "6"
                                            ? "4"
                                            : sportsPassForModal?.name === "12"
                                            ? t("unlimited").toUpperCase()
                                            : null}
                                        </span>
                                      </p>
                                      <p className="bundleProductPrice">
                                        $
                                        {sportsPassForModal?.name === "3"
                                          ? "9.98"
                                          : sportsPassForModal?.name === "6"
                                          ? "19.98"
                                          : sportsPassForModal?.name === "12"
                                          ? "74.85"
                                          : null}
                                      </p>
                                    </div>
                                  </div>
                                  <Button
                                    onClick={() =>
                                      isUserSportsPassHolder
                                        ? showUserIsAlreadySportsPassHolderPopup()
                                        : addItemToCart(product)
                                    }
                                    className="primaryBtn"
                                    disabled={doesCartContainSportPass()}
                                  >
                                    {t("addToCart").toUpperCase()}
                                  </Button>
                                </div>
                              </div>
                            </ModalBody>
                          </Modal>
                          <Button
                            onClick={() =>
                              isUserSportsPassHolder
                                ? showUserIsAlreadySportsPassHolderPopup()
                                : addItemToCart(product)
                            }
                            className="primaryBtn"
                            disabled={doesCartContainSportPass()}
                          >
                            {t("buyNow").toUpperCase()}
                          </Button>
                        </div>
                      </div>
                    );
                  }
                })
              }
            </ScrollMenu>
          </div>
        ) : null} */}
        {/*  */}
        {/* STAR COINS */}
        {!activeCategory || activeCategory === "STAR COINS" ? (
          <div className="shopPageSection">
            <h1>{t("starCoins").toUpperCase()}</h1>
            <ScrollMenu>
              <div className="shopCard">
                <div className="shopCardImageContainer">
                  <img
                    alt="productImage"
                    src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fproducts%2FstarCoins%2FTKStoSTC.png?alt=media&token=97fd2319-821c-47b0-aa28-19f7d89b960d"
                  />
                </div>
                <div style={{ padding: "1rem", paddingTop: "0.5rem" }}>
                  <p className="shopCardName">{t("convertTicketsTo")}</p>
                  <p className="shopCardPrice">
                    {t("starCoins").toUpperCase()}
                  </p>
                  <Button
                    onClick={toggleConvertStarCoinsToTicketsModal}
                    className="primaryBtn"
                  >
                    {t("convertNow").toUpperCase()}
                  </Button>
                </div>
              </div>
              <Modal
                id="convertStarCoinsToTicketsModal"
                isOpen={convertStarCoinsToTicketsModalIsOpen}
                toggle={toggleConvertStarCoinsToTicketsModal}
                size={"lg"}
              >
                <ModalBody>
                  <div className="modalHeader" style={{ marginBottom: "1rem" }}>
                    <div></div>
                    <IoClose onClick={toggleConvertStarCoinsToTicketsModal} />
                  </div>
                  <div>
                    <h1>{t("convertTicketsToStarCoins").toUpperCase()}</h1>
                    <div style={{ marginTop: "1rem" }}>
                      <p>
                        {t("youHave")}{" "}
                        <span style={{ fontWeight: "bold", color: "#FABB00" }}>
                          {userTickets}
                        </span>{" "}
                        tickets
                      </p>
                      <div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <div id="convertStarCoinsToTicketsTickets">
                            <p>{getTicketsToConvertDisplay()} ⭐️</p>
                          </div>
                          <p style={{ marginBottom: 0 }}>1 🎟️ = 10 ⭐️</p>
                        </div>
                        <p className="inputLabel">{t("ticketsToConvert")}</p>
                        <Input
                          type="number"
                          className="authInput"
                          value={value}
                          onChange={(e) => setValue(e.target.value)}
                          placeholder={t("ticketsToConvert")}
                          style={{ marginBottom: "1rem" }}
                        />
                        <button
                          onClick={convertTicketsToStarCoins}
                          className="primaryBtn"
                          disabled={value < 1 || value > userTickets}
                        >
                          {t("convertNow").toUpperCase()}
                        </button>
                      </div>
                    </div>
                  </div>
                </ModalBody>
              </Modal>
              {
                // eslint-disable-next-line
                products?.map((product) => {
                  if (product.category === "STAR COINS") {
                    return (
                      <div className="shopCard">
                        <div className="shopCardImageContainer">
                          <img
                            alt="productImage"
                            src={
                              product.image
                                ? product.image
                                : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
                            }
                          />
                        </div>
                        <div style={{ padding: "1rem", paddingTop: "0.5rem" }}>
                          <p className="shopCardName">{product.name}</p>
                          <p className="shopCardPrice">
                            ${parseFloat(product?.price).toFixed(2)}
                          </p>
                          <Button
                            onClick={() => addItemToCart(product)}
                            className="primaryBtn"
                          >
                            {t("buyNow").toUpperCase()}
                          </Button>
                        </div>
                      </div>
                    );
                  }
                })
              }
            </ScrollMenu>
          </div>
        ) : null}
        {/*  */}
        {/* AVATAR ICONS */}
        {!activeCategory || activeCategory === "AVATAR ICONS" ? (
          <div className="shopPageSection">
            <h1>{t("avatarIcons").toUpperCase()}</h1>
            <ScrollMenu>
              {
                // eslint-disable-next-line
                products?.map((product) => {
                  if (product.category === "AVATAR ICONS") {
                    return (
                      <div className="shopCard">
                        <div className="shopCardImageContainer">
                          <img
                            alt="productImage"
                            src={
                              product.image
                                ? product.image
                                : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
                            }
                          />
                        </div>
                        <div style={{ padding: "1rem", paddingTop: "0.5rem" }}>
                          <p className="shopCardName">{product.name}</p>
                          <p className="shopCardPrice">
                            ${parseFloat(product?.price)?.toFixed(2)}
                          </p>
                          <Button
                            onClick={() => addItemToCart(product)}
                            className="primaryBtn"
                            disabled={product?.purchaserUids?.includes(
                              user?.uid
                            )}
                          >
                            {product?.purchaserUids?.includes(user?.uid)
                              ? t("purchased").toUpperCase()
                              : t("buyNow").toUpperCase()}
                          </Button>
                        </div>
                      </div>
                    );
                  }
                })
              }
            </ScrollMenu>
          </div>
        ) : null}
        {/*  */}
        {!activeCategory || activeCategory === "PROFILE BANNERS" ? (
          <div className="shopPageSection">
            <h1>{t("profileBanners").toUpperCase()}</h1>
            <ScrollMenu>
              {
                // eslint-disable-next-line
                products?.map((product) => {
                  if (product.category === "PROFILE BANNERS") {
                    return (
                      <div
                        className="shopCard"
                        style={{ width: "fit-content" }}
                      >
                        <div
                          className="shopCardImageContainer"
                          style={{ height: 225, paddingBottom: "0.5rem" }}
                        >
                          <img
                            alt="productImage"
                            src={
                              product.image
                                ? product.image
                                : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
                            }
                            style={{ maxWidth: "none", borderRadius: 12 }}
                          />
                        </div>
                        <div style={{ padding: "1rem", paddingTop: "0.5rem" }}>
                          <p className="shopCardName">{product.name}</p>
                          <p className="shopCardPrice">
                            ${parseFloat(product?.price).toFixed(2)}
                          </p>
                          <Button
                            onClick={() => addItemToCart(product)}
                            className="primaryBtn"
                            disabled={product?.purchaserUids?.includes(
                              user?.uid
                            )}
                          >
                            {product?.purchaserUids?.includes(user?.uid)
                              ? t("purchased").toUpperCase()
                              : t("buyNow").toUpperCase()}
                          </Button>
                        </div>
                      </div>
                    );
                  }
                })
              }
            </ScrollMenu>
          </div>
        ) : null}
        {/* {
          !activeCategory || activeCategory === 'EMOJIS' ?
            <div className='shopPageSection'>
              <h1>
                EMOJIS
              </h1>
              <ScrollMenu>
                {
                  // eslint-disable-next-line
                  products?.map(product => {
                    if (product.category === 'EMOJIS'){
                      return (
                        <div className='shopCard'>
                          <div className='shopCardImageContainer'>
                            <img
                              alt="productImage"
                              src={product.image ? product.image : 'https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3'}
                            />
                          </div>
                          <div style={{padding: '1rem', paddingTop: '0.5rem'}}>
                            <p className='shopCardName'>
                              {product.name}
                            </p>
                            <p className='shopCardPrice'>
                              ${product.price.toFixed(2)}
                            </p>
                            <Button onClick={() => addItemToCart(product)} className='primaryBtn'>
                              BUY NOW
                            </Button>
                          </div>
                        </div>
                      )
                    }
                  })
                }
              </ScrollMenu>
            </div>
            : null
        }
        {
          !activeCategory || activeCategory === 'STICKERS' ?
            <div className='shopPageSection'>
              <h1>
                STICKERS
              </h1>
              <ScrollMenu>
                {
                  // eslint-disable-next-line
                  products?.map(product => {
                    if (product.category === 'STICKERS'){
                      return (
                        <div className='shopCard'>
                          <div className='shopCardImageContainer'>
                            <img
                              alt="productImage"
                              src={product.image ? product.image : 'https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3'}
                            />
                          </div>
                          <div style={{padding: '1rem', paddingTop: '0.5rem'}}>
                            <p className='shopCardName'>
                              {product.name}
                            </p>
                            <p className='shopCardPrice'>
                              ${product.price.toFixed(2)}
                            </p>
                            <Button onClick={() => addItemToCart(product)} className='primaryBtn'>
                              BUY NOW
                            </Button>
                          </div>
                        </div>
                      )
                    }
                  })
                }
              </ScrollMenu>
            </div>
            : null
        } */}
        {/* {
          !activeCategory || activeCategory === 'TICKET BOOSTS' ?
            <div className='shopPageSection'>
              <h1>
                {t('ticketBoosts').toUpperCase()}
              </h1>
              <ScrollMenu>
                {
                  // eslint-disable-next-line
                  products?.map(product => {
                    if (product.category === 'TICKET BOOSTS'){
                      return (
                        <div className='shopCard'>
                          <div className='shopCardImageContainer'>
                            <img
                              alt="productImage"
                              src={product.image ? product.image : 'https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3'}
                            />
                          </div>
                          <div style={{padding: '1rem', paddingTop: '0.5rem'}}>
                            <p className='shopCardName'>
                              {product.name}
                            </p>
                            <p className='shopCardPrice'>
                              ${parseFloat(product?.price).toFixed(2)}
                            </p>
                            <Button onClick={() => addItemToCart(product)} className='primaryBtn'>
                              {t('buyNow').toUpperCase()}
                            </Button>
                          </div>
                        </div>
                      )
                    }
                  })
                }
              </ScrollMenu>
            </div>
            : null
        } */}
        {/* {
          !activeCategory || activeCategory === 'CREATE GROUP TOKENS' ?
            <div className='shopPageSection'>
              <h1>
                CREATE GROUP TOKENS
              </h1>
              <ScrollMenu>
                {
                  // eslint-disable-next-line
                  products?.map(product => {
                    if (product.category === 'CREATE GROUP TOKENS'){
                      return (
                        <div className='shopCard'>
                          <div className='shopCardImageContainer'>
                            <img
                              alt="productImage"
                              src={product.image ? product.image : 'https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3'}
                            />
                          </div>
                          <div style={{padding: '1rem', paddingTop: '0.5rem'}}>
                            <p className='shopCardName'>
                              {product.name}
                            </p>
                            <p className='shopCardPrice'>
                              ${product.price.toFixed(2)}
                            </p>
                            <Button onClick={() => addItemToCart(product)} className='primaryBtn'>
                              BUY NOW
                            </Button>
                          </div>
                        </div>
                      )
                    }
                  })
                }
              </ScrollMenu>
            </div>
            : null
        } */}
        {!activeCategory || activeCategory === "REWARDS" ? (
          <div className="shopPageSection">
            <h1>{t("rewards").toUpperCase()}</h1>
            <div id="shopRewardsN1coContainer">
              <N1coInfoModal />
              <RewardHistoryModal />
              <a
                href="https://n1co.com/tarjeta-n1co/"
                target="_blank"
                rel="noreferrer"
              >
                <button className="primaryBtn">
                  {t("downloadN1co").toUpperCase()}
                </button>
              </a>
            </div>
            <ScrollMenu>
              {
                // eslint-disable-next-line
                rewards?.map((product) => {
                  return (
                    <div className="shopCard">
                      <div className="shopCardImageContainer">
                        <img
                          alt="productImage"
                          src={
                            product.image
                              ? product.image
                              : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
                          }
                        />
                      </div>
                      <div style={{ padding: "1rem", paddingTop: "0.5rem" }}>
                        <p className="shopCardName">{product.name}</p>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <p className="shopCardPrice">
                            🎟️&nbsp;&nbsp;
                            {product.priceInTickets.toLocaleString()}
                          </p>
                          <p style={{ color: "#FFFFFF" }}>
                            {product?.quantityAvailable}/
                            {product?.totalQuantity}
                          </p>
                        </div>
                        <Button
                          onClick={() => handleRedeemButtonClick(product)}
                          className="primaryBtn"
                        >
                          {t("redeem").toUpperCase()}
                        </Button>
                      </div>
                    </div>
                  );
                })
              }
              <Modal
                id="redeemTicketsForRewardModal"
                isOpen={redeemTicketsForRewardModalIsOpen}
                toggle={toggleRedeemTicketsForRewardModal}
                size={"lg"}
              >
                <ModalBody>
                  <div className="modalHeader" style={{ marginBottom: "1rem" }}>
                    <div></div>
                    <IoClose onClick={toggleRedeemTicketsForRewardModal} />
                  </div>
                  <div>
                    <h1>{t("redeemTickets").toUpperCase()}</h1>
                    <div style={{ marginTop: "1rem" }}>
                      <p>
                        {t("youHave")}{" "}
                        <span style={{ fontWeight: "bold", color: "#FABB00" }}>
                          {userTickets}
                        </span>{" "}
                        tickets
                      </p>
                      <p>
                        {t("areYouSureYouWantToRedeem")}{" "}
                        <span style={{ fontWeight: "bold", color: "#FF0000" }}>
                          {rewardForModal?.priceInTickets?.toLocaleString()}
                        </span>{" "}
                        tickets {t("for")}{" "}
                        <span style={{ fontWeight: "bold", color: "#FABB00" }}>
                          {rewardForModal?.name}
                        </span>
                        ?
                      </p>
                      {rewardForModal?.disclaimer ? (
                        <p style={{ color: "#00000075" }}>
                          {t("disclaimer")}:<br />
                          {rewardForModal?.disclaimer}
                        </p>
                      ) : null}
                      <Button
                        onClick={redeemTicketsForReward}
                        className="primaryBtn"
                        style={{ marginBottom: "0.5rem" }}
                        disabled={rewardForModal?.priceInTickets > userTickets}
                      >
                        {t("redeem").toUpperCase()}
                      </Button>
                      <Button
                        onClick={toggleRedeemTicketsForRewardModal}
                        className="secondaryBtn"
                        style={{ color: "#005EE1" }}
                      >
                        {t("cancel").toUpperCase()}
                      </Button>
                    </div>
                  </div>
                </ModalBody>
              </Modal>
            </ScrollMenu>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default ShopPage;
